import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeRecordPaySlipDownloadHistoryParams = {
  /**
   * 급여명세서 유형
   * @remarks 일급: PER_DIEM, 주휴수당: HOLIDAY, 특근: SPECIAL_PRO, 연차수당: ANNUAL, 월별: MONTHLY
   */
  payslipType: string;
  /** 급여지급일자 (yyyy-MM-dd) */
  paymentDate: string;
  /** 급여명세서 데이터 */
  rawPayslipData: string;
};

type TypeRecordPaySlipDownloadHistoryResponse = {
  /** 응답 코드 */
  code: string;
  /** 응답 메시지 */
  message: string;
  data: {
    id: string;
    laborAccountId: number;
    laborUsername: string;
    requestedAt: string;
    requestIpAddress: string;
    requestPayslipType: {
      code: string;
      text: string;
    };
    paymentDate: string;
    createdAt: string;
    createdBy: string;
    updatedAt: string | null;
    updatedBy: string | null;
  };
};

/** @description 급여명세서 다운로드 이력 추가 api 요청에 사용되는 커스텀 훅 */
export const useRecordPaySlipDownloadHistory = () => {
  const queryClient = useQueryClient();

  const requestRecordPaySlipDownloadHistory = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRecordPaySlipDownloadHistoryParams;
    onSuccess?: (response: TypeRecordPaySlipDownloadHistoryResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    const endpoint = '/labor/payslips/register-download-history';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeRecordPaySlipDownloadHistoryResponse>>({
      queryKey: ['recordPaySlipDownloadHistory', params.payslipType, params.paymentDate],
      queryFn: () => axiosInstance.post(endpoint, params),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestRecordPaySlipDownloadHistory;
};
